import { isAsbestosPmId } from '@ivario-arc/shared/src/sampleResults/asbestos.ts';
import { useNavigate } from 'react-router';
import {
  OVERVIEW_CONTACT_MOLD_PARAMETER_ID,
  OVERVIEW_SEDIMENT_MOLD_PARAMETER_ID,
} from '@ivario-arc/shared/src/sampleResults/mold.ts';
import { ConfigDto, SampleDetailsDto } from '@src/types/types';
import { ParameterList } from '@components/atoms/ParameterList';
import { ProductCertificate } from '@components/sample-details/ProductCertificate';
import { AsbestosResults } from '@components/sample-details/AsbestosResults.tsx';
import { Paths } from '@src/routes/paths.ts';
import { SedimentMoldResults } from '@components/sample-details/mold/SedimentMoldResults.tsx';
import { ContactMoldResults } from '@components/sample-details/mold/ContactMoldResults.tsx';

interface SampleDetailsProps {
  sample: SampleDetailsDto;
  config: ConfigDto;
}

export const SampleDone = ({ sample, config }: SampleDetailsProps) => {
  const navigate = useNavigate();
  let resultsComponent = null;

  if (isSedimentMoldResults(sample)) {
    resultsComponent = <SedimentMoldResults sample={sample} />;
  } else if (isContactMoldResults(sample)) {
    resultsComponent = <ContactMoldResults sample={sample} />;
  } else if (isAsbestosResults(sample)) {
    resultsComponent = (
      <AsbestosResults
        sample={sample}
        configuration={config}
        backToProfile={() => navigate(Paths.PROFILE)}
      />
    );
  } else {
    resultsComponent = <ParameterList parameters={sample.parameters} />;
  }

  return (
    <>
      {sample.productCertificate ? (
        <ProductCertificate certificate={sample.productCertificate!} />
      ) : null}
      {resultsComponent}
    </>
  );
};

const isAsbestosResults = (sample: SampleDetailsDto) => {
  return (
    sample.parameters?.some((parameter) => isAsbestosPmId(parameter.pmId)) ??
    false
  );
};

const isSedimentMoldResults = (sample: SampleDetailsDto) => {
  return (
    sample.parameters?.some(
      (parameter) => parameter.pmId === OVERVIEW_SEDIMENT_MOLD_PARAMETER_ID,
    ) ?? false
  );
};

const isContactMoldResults = (sample: SampleDetailsDto) => {
  return (
    sample.parameters?.some(
      (parameter) => parameter.pmId === OVERVIEW_CONTACT_MOLD_PARAMETER_ID,
    ) ?? false
  );
};
